"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeathAvoidedEventArgs = void 0;
const EventType_1 = require("../EventType");
class DeathAvoidedEventArgs {
    constructor(consumedAvoidanceEffect) {
        this.consumedAvoidanceEffect = consumedAvoidanceEffect;
        this.__type = EventType_1.EventType.DeathAvoided;
        this.__typeName = "DeathAvoided";
    }
}
exports.DeathAvoidedEventArgs = DeathAvoidedEventArgs;
